import './style.css';

import iconWidget from '../../assets/images/widgetIcon.png';
import { useState } from 'react';

interface IFloatVideoCta {
  videoUrl: string;
}

export function FloatVideoCta({ videoUrl }: IFloatVideoCta) {
  const isShowed = localStorage.getItem('isShowedCtaLogin');
  const [showModal, setShowModal] = useState(true);

  function closeWidget() {
    setShowModal(false);
    const wrapperWi = document.getElementsByClassName('wrapper-wi')[0];
    wrapperWi.classList.remove('animate__bounceIn');
    wrapperWi.classList.remove('animate__delay-3s');
    wrapperWi.classList.add('animate__bounceOut');
    localStorage.setItem('isShowedCtaLogin', 'true');
    setTimeout(() => {
      wrapperWi.remove();
    }, 1000);
  }

  return (
    <>
      {showModal && !isShowed && (
        <>
          <div className="wrapper-wi animate__animated animate__bounceIn animate__delay-3s">
            <div className="box-cta-wi">
              <div className="header-cta-wi">
                <div className="content-left">
                  <span>Veja como funciona</span>
                </div>
                <div className="content-right">
                  <button
                    className="close-wi "
                    onClick={() => {
                      closeWidget();
                    }}
                  >
                    <i className="material-icons-outlined">close</i>
                  </button>
                  <a href={videoUrl} target="_blank" className="btn-cta-wi">
                    Ver agora
                    <i className="material-icons-outlined">
                      play_circle_filled
                    </i>
                  </a>
                </div>
              </div>
              <div className="content-cta-wi">
                <div
                  className="step"
                  style={{ backgroundColor: 'transparent' }}
                >
                  <div className="initial"></div>
                </div>
                <div className="divider-step">
                  <div className="line"></div>
                </div>
                <div className="step-label">
                  <span>Faça o cadastro</span>
                  <div className="step">
                    <span>1</span>
                  </div>
                </div>
                <div className="divider-step">
                  <div className="line"></div>
                </div>
                <div className="step-label">
                  <span>Compartilhe as ofertas</span>
                  <div className="step">
                    <span>2</span>
                  </div>
                </div>
                <div className="divider-step">
                  <div className="line"></div>
                </div>
                <div className="step-label">
                  <span>Indique os amigos</span>
                  <div className="step">
                    <span>3</span>
                  </div>
                </div>
                <div className="divider-step">
                  <div className="line"></div>
                </div>
                <div className="step-label">
                  <span>A gente vende</span>
                  <div className="step">
                    <span>4</span>
                  </div>
                </div>
                <div className="divider-step">
                  <div className="line"></div>
                </div>
                <div className="step-label">
                  <span>
                    Você
                    <br />
                    ganha
                  </span>
                  <div className="step">
                    <span>5</span>
                  </div>
                </div>
                <div className="divider-step">
                  <div className="line"></div>
                </div>
                <div
                  className="step"
                  style={{
                    backgroundColor: 'transparent',
                    width: '100px',
                    height: '100px',
                  }}
                >
                  <img src={iconWidget} alt="" />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
